import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeComponentProps as _mergeComponentProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("announcement-bar__container-35e5ta", {
  display: "flex",
  alignItems: "flex-start"
});
const _staticStyles2 = _cssRef("announcement-bar__typography-1opvyd", {
  fontSize: "16px",
  "& p": {
    marginBottom: "6px"
  },
  "& a": {
    fontWeight: "bold",
    textDecoration: "underline"
  },
  "@media (max-width: 767px)": {
    display: "none"
  }
});
const _staticStyles3 = _cssRef("announcement-bar__styledbuttonaslink-1hanfd", {
  marginTop: "10px",
  marginBottom: "10px",
  "@media (max-width: 767px)": {
    display: "none"
  }
});
const _staticStyles4 = _cssRef("announcement-bar__typography-1x7kn9", {
  fontSize: "16px",
  "& p": {
    marginBottom: "6px"
  },
  "& a": {
    fontWeight: "bold",
    textDecoration: "underline"
  },
  display: "none",
  "@media (max-width: 767px)": {
    display: "block"
  }
});
const _staticStyles5 = _cssRef("announcement-bar__styledbuttonaslink-0yucq0", {
  marginTop: "10px",
  marginBottom: "10px"
});
const _staticStyles6 = _cssRef("announcement-bar__button-38n0l7", {
  display: "none",
  "@media (max-width: 767px)": {
    display: "flex"
  }
});
const _staticStyles7 = _cssRef("announcement-bar__closebutton-1id0kp", {
  position: "relative",
  color: "var(--system-white)"
});
import React from 'react';
import IconArrow from '../../../images/svg/arrow-forward.svg';
import IconArrowBack from '../../../images/svg/arrow-back.svg';
import { colors } from '../../primitives/colors';
import useLocalStorageState from '../../../hooks/use-local-storage-state';
import Typography from '../../primitives/typography';
import { breakpoints } from '../../primitives/tokens';
import Button from '../../primitives/button';
import { useLocator } from '../../../contexts/franchise/locator-provider';
import Container from '../../primitives/grid/container';
import CloseButton from '../../primitives/close-button';
import { StyledButtonAsLink } from '../../primitives/styled-button';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
const LOCAL_STORAGE_KEY = 'servpro-announcement-closed';
interface SingleAnnouncementProps {
  id?: string;
  title?: string | null;
  copy?: string | null;
  enable?: boolean | null;
  callToAction?: ContentStackLink | null;
}
const SingleAnnouncement = ({
  id,
  title,
  copy,
  enable,
  callToAction
}: SingleAnnouncementProps): JSX.Element | null => {
  const {
    title: ctaTitle,
    href: ctaHref
  } = callToAction || {};
  const [expanded, setExpanded] = React.useState(false);
  const {
    data: isClosed,
    setData: setIsClosed,
    loading
  } = useLocalStorageState<boolean | null>(`${LOCAL_STORAGE_KEY}-${id}`, async () => false, [], 36, () => true);
  if (!enable) {
    return null;
  }
  if (isClosed || loading) return null;
  return <div className="announcement-bar__div-0v0rmk">
            <Container {..._mergeComponentProps({
      css: _staticStyles
    })}>
                <div className="announcement-bar__div-3mhsa7">
                    <Typography fontSize="xl" fontWeight="medium">{title}</Typography>
                    <Typography {..._mergeComponentProps({
          css: _staticStyles2,
          fontSize: "sm",
          dangerouslySetInnerHTML: {
            __html: copy || ''
          }
        })} />
                    {ctaHref && ctaTitle && <StyledButtonAsLink {..._mergeComponentProps({
          css: _staticStyles3,
          to: ctaHref
        })}>
                            {ctaTitle}
                        </StyledButtonAsLink>}
                    <div style={{
          display: expanded ? 'block' : 'none'
        }}>
                        <Typography {..._mergeComponentProps({
            css: _staticStyles4,
            fontSize: "sm",
            dangerouslySetInnerHTML: {
              __html: copy || ''
            }
          })} />
                        {ctaHref && ctaTitle && <StyledButtonAsLink {..._mergeComponentProps({
            css: _staticStyles5,
            to: ctaHref
          })}>{ctaTitle}</StyledButtonAsLink>}
                    </div>
                    <Button {..._mergeComponentProps({
          css: _staticStyles6,
          onClick: () => {
            setExpanded(!expanded);
          }
        })}>
                        {expanded && <div className="announcement-bar__div-2e9enc">
                                <IconArrowBack aria-hidden="true" focusable="false" className="announcement-bar__iconarrowback-39p7oy" />
                                <span>Show Less</span>
                            </div>}
                        {!expanded && <div className="announcement-bar__div-2e9enc">
                                <span>Read More</span>
                                <IconArrow aria-hidden="true" focusable="false" className="announcement-bar__iconarrow-07zk6c" />
                            </div>}
                    </Button>
                </div>
                <CloseButton {..._mergeComponentProps({
        css: _staticStyles7,
        onClick: () => {
          setIsClosed(true);
        }
      })} />

            </Container>
        </div>;
};
const AnnouncementBar = (): JSX.Element | null => {
  const {
    franchise
  } = useMicrosite();
  const {
    announcements
  } = useLocator();
  const {
    relevantAnnouncements: franchiseLevelAnnouncements
  } = franchise || {};
  if (franchiseLevelAnnouncements || announcements) {
    return <>
                {(franchiseLevelAnnouncements || announcements).map(x => <SingleAnnouncement key={x.uid} id={x.uid} {...x} />)}
            </>;
  }
  return null;
};
export default AnnouncementBar;